export default __webpack_public_path__ + "static/media/brain.7577f198.svg";